export default {
  link_expired: "Link expired",
  accountVerified: "Account activated successfully! Sign in to start the journey.",
  gmi: "Get Me in",
  Sign_In :"Sign in",
  Creating_Account: "Creating Account",
};
